import { ThemeProvider } from "@emotion/react";
import { Stack, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { NotificationType } from "constants/NotificationConstants";
import { notificationButtonsTheme } from "../notificationButtonsTheme";
import UnreadNotificationsNumber from "../Notifications/UnreadNotificationsNumber";
import { ALL_SECTION_NAME, IMPORTANT_SECTION_NAME } from "../NotificationZone";

import "../NotificationZone.scss";

type Props = {
  selectedNotificationSectionType: string;
  onSectionChange: (newSection: string) => void;
  onSectionClick: () => void;
  nbUnreadNotifications: number;
  nbUnreadImportantNotifications: number;
};

const NotificationZoneHeaderButtons: React.FC<Props> = ({
  selectedNotificationSectionType,
  onSectionChange,
  onSectionClick,
  nbUnreadNotifications,
  nbUnreadImportantNotifications,
}: Props) => {
  return (
    <Stack
      className="notification-section-buttons"
      direction="row"
      spacing={0}
      sx={{
        justifyContent: "space-around",
        alignItems: "center",
      }}>
      <ThemeProvider theme={notificationButtonsTheme}>
        <ToggleButtonGroup
          color="primary"
          value={selectedNotificationSectionType}
          exclusive
          onChange={(_, newValue: string | null) => {
            if (newValue !== null) onSectionChange(newValue);
          }}
          onClick={onSectionClick}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}
          aria-label="Zone de notifications">
          <ToggleButton
            className="notification-section-button"
            value={ALL_SECTION_NAME}
            aria-label="Toutes les notifications"
            style={{
              width: "155px",
              height: "40px",
              borderRadius: "80px",
            }}>
            {ALL_SECTION_NAME}
            <UnreadNotificationsNumber
              notificationType={NotificationType.NORMAL}
              nbUnreadNotifications={nbUnreadNotifications}
            />
          </ToggleButton>
          <ToggleButton
            value={IMPORTANT_SECTION_NAME}
            className="notification-section-button"
            aria-label="Notifications importantes"
            style={{
              width: "155px",
              height: "40px",
              borderRadius: "80px",
            }}>
            {IMPORTANT_SECTION_NAME}
            <UnreadNotificationsNumber
              notificationType={NotificationType.IMPORTANT}
              nbUnreadNotifications={nbUnreadImportantNotifications}
            />
          </ToggleButton>
        </ToggleButtonGroup>
      </ThemeProvider>
    </Stack>
  );
};
export default NotificationZoneHeaderButtons;
